import { usePaginatedApi } from "../../../swr/useApi";
import { salesService } from "../../api_client";
import type { SaleDto, SalesQueryDto } from "../../../api";
import { SalesQueryDtoStateEnum } from "../../../api";

export type QuotationFilter = "all" | "pending" | "paid" | "expired";

const STATE_FOR_FILTER: Record<QuotationFilter, SalesQueryDtoStateEnum | undefined> = {
  all: undefined,
  pending: undefined,
  paid: SalesQueryDtoStateEnum.Sale,
  expired: SalesQueryDtoStateEnum.Sent,
};

export function useQuotations(
  filter: QuotationFilter,
  query?: Omit<SalesQueryDto, "state">,
) {
  const finalQuery: SalesQueryDto = {
    ...query,
    state: STATE_FOR_FILTER[filter],
    notExpired: filter === "pending" ? true : undefined,
  } as SalesQueryDto;

  return usePaginatedApi<SaleDto, SalesQueryDto>({
    key: `quotations-${filter}`,
    serviceMethod: async (q) => await salesService.getSales(q),
    query: finalQuery,
  });
}
